import { UFile } from '@w/utils'
import { uid } from '@w/utils'
import { imagePool } from './image-worker-pool'
import type { ProcessImageOptions } from './image-worker'

export interface ProcessImageResult {
  file: UFile
  thumb: string
}

export type { ProcessImageOptions }

export async function processImage(
  file: UFile,
  opts?: ProcessImageOptions,
): Promise<ProcessImageResult> {
  const result = await imagePool.processImage(file.blob, opts)

  const name = `${result.thumb}-${uid(6)}.avif`
  const avifFile = new UFile(
    new Blob([result.avifBuffer], { type: 'image/avif' }),
    { path: file.dirPath ? `${file.dirPath}/${name}` : name },
  )

  return {
    file: avifFile,
    thumb: result.thumb,
  }
}
